export const ratingToPercent = (rating) => {
  const value = typeof rating === 'number' ? rating : Number(rating);
  if (!Number.isFinite(value) || value <= 0) { return null; }
  const bounded = Math.min(5, value);
  return `${Math.round((bounded / 5) * 100)}%`;
};
